import ErrorOutlinedIcon from '@mui/icons-material/ErrorOutlined';
import { Box, Button, Typography } from '@mui/material';
import { useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { authQueryKeys } from '../hooks/auth/use-memberships';
import { consentQueryKeys } from '../hooks/consent/use-consent';
import { onboardingQueryKeys } from '../hooks/use-onboarding';
import { permissionQueryKeys } from '../hooks/use-permissions';
import { ONBOARDING_PROFILE_SEED_QUERY_KEY } from '../pages/onboarding/onboarding-state';

export function BootstrapError() {
  const { t } = useTranslation('common');
  const queryClient = useQueryClient();

  const handleRetry = () => {
    queryClient.invalidateQueries({ queryKey: authQueryKeys.memberships() });
    queryClient.invalidateQueries({ queryKey: onboardingQueryKeys.statusRoot() });
    queryClient.invalidateQueries({ queryKey: permissionQueryKeys.meRoot() });
    queryClient.invalidateQueries({ queryKey: consentQueryKeys.root() });
    queryClient.invalidateQueries({ queryKey: ONBOARDING_PROFILE_SEED_QUERY_KEY });
  };

  return (
    <Box
      sx={{
        position: 'fixed',
        zIndex: 9999,
        top: 0,
        left: 0,
        width: '100vw',
        height: '100dvh',
        backgroundColor: '#ffffff',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
        px: 4,
      }}
    >
      <ErrorOutlinedIcon sx={{ fontSize: 64, color: '#0F172A' }} />
      <Typography variant="h6" sx={{ fontWeight: 600, textAlign: 'center' }}>
        {t('bootstrapError.title')}
      </Typography>
      <Typography variant="body2" sx={{ color: 'text.secondary', textAlign: 'center' }}>
        {t('bootstrapError.subtitle')}
      </Typography>
      <Button variant="contained" onClick={handleRetry} sx={{ mt: 1 }}>
        {t('bootstrapError.retryButton')}
      </Button>
    </Box>
  );
}
